import {memo, useState} from "react";
import PortraitControlbar from "../../mainComponent/footer/controllbar/portraitControlbar";
import { useAppSelector } from "redux-share/hooks";
import { conditions, getRemainingTime, unitization } from "helpers";
import { ConditionName } from "interfaces";
import { shallowEqual } from 'react-redux'
import dynamic from "next/dynamic";
import LiveStatus from "../liveStatus/liveStatus";

const TruncateMarkup = dynamic(() => import("react-truncate-markup"));
const ElapsedTime = dynamic(() => import("../elapsedTime/elapsedTime"));
const Tags = dynamic(() => import("../tags/tags"));
const OnlineViewersIcon = dynamic(() => import("../../icon-components/onlineViewerIcon"));
const MovieDetail = dynamic(() => import("../movie/movieDetail/movieDetail"));
const Trailer = dynamic(() => import("../trailer/trailer"));
const Skeleton = dynamic(() => import("../skeleton/skeleton"));
const PlayList = dynamic(() => import("../playList/playList"));
const RecommendationList = dynamic(() => import("../recommendationList/recommendationList"));
const Comments = dynamic(() => import("../comments/comments"));
const TabNavigator = dynamic(() => import("../tabNavigator/TabNavigator"));

const ComplexPortrait = () => {

    const [showCompleteDescription, setShowCompleteDescription] = useState<boolean>(false);

    const { details, params, onlineViewers } = useAppSelector(({ videoData: { details, params, onlineViewers, recommendationList, playList, trailer } }) => ({ details, params, onlineViewers, recommendationList, playList, trailer }), shallowEqual);
    useAppSelector(({ controller: { isEnded } }) => ({ isEnded }), shallowEqual);
    useAppSelector(({ user: { isLogin } }) => ({ isLogin }), shallowEqual);
    useAppSelector(({ popovers: { playListPopover } }) => ({ playListPopover }), shallowEqual);
    useAppSelector(({ comments: { canAddComment, commentsCount } }) => ({ canAddComment, commentsCount }), shallowEqual);

    return (
        <div className="pl-h-screen pl-bg-white dark:!pl-bg-dark-1 pl-overflow-x-hidden pl-overflow-y-auto no-scrollbar">
            <div className={`pl-flex pl-flex-col pl-gap-4 pl-mx-3 pl-mb-3 pl-bg-white dark:pl-bg-dark-1`}>
                <div className="pl-text-white pl-mt-2">
                    <div className="pl-flex pl-gap-1 pl-justify-between pl-items-start">
                        <h1 className="pl-text-[14px] pl-text-gray-800 dark:pl-text-dark-5 pl-font-bold pl-two-line">{conditions(ConditionName.hasTitle) ? details.title : params.id}</h1>
                        {conditions(ConditionName.showElapsedTime) && <ElapsedTime/>}
                        {conditions(ConditionName.showLiveStatusInComplexPortrait) && !conditions(ConditionName.isIOSLive) && <LiveStatus/>}
                    </div>
                    {conditions(ConditionName.hasTags) && (
                        <div className="pl-flex pl-overflow-hidden pl-mt-4 pl-mb-3">
                            <Tags tagId={String(params.id)} tags={details.tag!} />
                        </div>
                    )
                    }
                    <div
                        className="pl-flex pl-items-center pl-gap-1 pl-text-[12px] pl-text-dark-4 dark:pl-text-dark-4 pl-font-normal">
                        {
                            conditions(ConditionName.isLiveParam) ? (
                                conditions(ConditionName.thresholdOnlineViewers) && (
                                    <div className={`pl-flex pl-items-center pl-gap-1`}>
                                        <OnlineViewersIcon className={`${conditions(ConditionName.isDarkMode) ? "pl-fill-dark-4" : "pl-fill-z-gray-500"}`}/>
                                        <div
                                            className="pl-flex pl-items-center pl-gap-0.5 pl-text-z-gray-500 dark:pl-text-dark-5 pl-text-[12px] pl-font-normal pl-relative pl-top-[1px]">
                                            <div>{unitization(onlineViewers!).unit}</div>
                                            <div>{unitization(onlineViewers!).value}</div>
                                        </div>
                                        {" ."}
                                    </div>
                                )
                            ) : (!conditions(ConditionName.hasMovieDetails) && conditions(ConditionName.showVideoUploadTime)) &&
                                <div>{getRemainingTime(details.start_time!)}{" ."}</div>
                        }
                        {conditions(ConditionName.showVideoViewers) && (
                          <div className="pl-flex pl-items-center pl-gap-1 pl-text-center">
                            <span>{conditions(ConditionName.isLiveParam) ? details.live_viewers : details.viewers}</span>
                            <span>بازدید</span>
                          </div>
                        )}
                    </div>
                </div>
                <PortraitControlbar />
                {(conditions(ConditionName.hasMovieDetails) || (conditions(ConditionName.hasDescription) && !conditions(ConditionName.hasTrailer))) && (
                    <div className="pl-border-b pl-border-secondary-500 pl-pb-4">
                        <div className="pl-flex pl-flex-col pl-gap-4 pl-bg-gray-highLight dark:pl-bg-dark-2 pl-rounded-[16px] pl-px-3 pl-py-4">
                            {conditions(ConditionName.hasMovieDetails) && <MovieDetail />}
                            {
                                !conditions(ConditionName.hasTrailer) && conditions(ConditionName.hasDescription) && (
                                    <>
                                        {showCompleteDescription ? (
                                            <div
                                                className="pl-max-w-screen pl-overflow-hidden pl-text-[14px] pl-font-normal pl-whitespace-pre-wrap pl-flex-1 no-scrollbar pl-text-justify">
                                                {details.description}
                                                <span onClick={() => setShowCompleteDescription(false)} className="pl-text-primary-600">{"کمتر..."}</span>
                                            </div>
                                        ) :
                                            (
                                                <TruncateMarkup
                                                    ellipsis={() => <span onClick={() => setShowCompleteDescription(true)} className="pl-text-primary-600">{" بیشتر..."}</span>}
                                                    lines={2}
                                                >
                                                    <div className="pl-text-[14px] pl-font-normal pl-flex-1 no-scrollbar pl-text-justify">{details.description}</div>
                                                </TruncateMarkup>
                                            )}
                                    </>
                                )
                            }
                        </div>
                    </div>
                )}
                {!conditions(ConditionName.isBeforeRequest) && <Trailer />}
            </div>
            {
                conditions(ConditionName.isBeforeRequest) ?
                <div className="pl-mx-3">
                    {
                        Array.from(Array(5).keys()).map((item, index) => <Skeleton key={index}/>)
                    }
                </div>
                :
                    <>
                        {conditions(ConditionName.hasPlayList) && <PlayList/>}
                        {conditions(ConditionName.showCommentComponent) && <Comments/>}
                        {conditions(ConditionName.hasRecommendationList) && conditions(ConditionName.showRecommendationList) && <RecommendationList/>}
                    </>
            }
            {conditions(ConditionName.showTabNavigator) && <TabNavigator />}

        </div>
    )
}

export default memo(ComplexPortrait);